import { Layout } from "components";

import ClientsTable from "../../components/Modules/ClientsTable";

const Clients = () => {
  return (
    <Layout>
       <ClientsTable/>
    </Layout>
  );
};

export default Clients;